import { PDFHeader } from './PDFHeader'

export const PDFImageWithLegend = async ({
  pdf,
  imgData,
  currentY,
  imgWidth,
  imgHeight,
  data,
  pageHeight,
  statusColors,
  legend = true,
  headerImage,
  chartElement,
  instituteDetails,
  year,
}) => {
  pdf.addImage(imgData, 'PNG', 15, currentY, imgWidth, imgHeight)
  // Define legend dimensions
  const legendStartX = 80 // Base X position for the first column
  const secondColumnX = legendStartX + 50 // Spacing for the second column
  const legendRowSpacing = 13 // Space between rows
  const legendRadius = 2 // Circle size

  // Check if there's space for the legend, otherwise add a new page
  const legendHeight = Math.ceil(data.length / 2) * legendRowSpacing
  if (currentY + legendHeight > pageHeight - 20) {
    pdf.addPage()

    await PDFHeader({
      pdf,
      headerImage,
      instituteDetails,
      chartElement,
      year,
    })

    currentY = 50 // Reset Y position
  }

  // Draw Legend
  if (legend) {
    for (let i = 0; i < data.length; i++) {
      const color = statusColors[data[i]?.label?.toLowerCase()] ||
        data[i]?.rgb || [0, 0, 0] // Default to black

      // Determine which column to use
      const isSecondColumn = i % 2 !== 0
      const legendX = isSecondColumn ? secondColumnX : legendStartX
      const legendY = currentY + 10 + Math.floor(i / 2) * legendRowSpacing // Adjust Y position

      // Check if legend fits, otherwise add a new page
      if (legendY + legendRowSpacing > pageHeight - 20) {
        pdf.addPage()

        await PDFHeader({
          pdf,
          headerImage,
          instituteDetails,
          chartElement,
          year,
        })

        currentY = 50
      }

      pdf.setFillColor(...color)
      pdf.circle(legendX, legendY, legendRadius, 'F') // Draw filled circle
      pdf.setFont('helvetica', 'normal', 'bold')
      pdf.setFontSize(10)
      const valueText = `${data[i]?.value}`
      const displayText = valueText.endsWith('%') ? valueText : `${valueText}%`
      pdf.text(displayText, legendX + 10, legendY)

      pdf.setFont('helvetica', 'normal', 400)
      let label = data[i]?.label?.trim()
      pdf.text(`${label}`, legendX + 10, legendY + 5)
    }
  }
  return currentY
}
